import { langJson } from '@helpers/consts';
import { MegaMenuColumn, MegaMenuColumnSection } from '@layouts/MegaMenu/MegaMenu.types';

export function activeClass(defaultClass, cond, crossIcon = true) {
  return cond && crossIcon ? `${defaultClass} active` : defaultClass;
}

export function sortArray<T extends { Name?: string; Title?: string }>(arr: T[]): T[] {
  const localLang = window.lang;
  const lang = langJson.find((element) => element.code === localLang.toLowerCase());
  const collator = new Intl.Collator(lang?.value || 'en', { sensitivity: 'variant' });

  return arr.sort((a, b) => {
    const strOne = a.Title ?? a.Name;
    const strTwo = b.Title ?? b.Name;

    return collator.compare(strOne, strTwo);
  });
}

export const sortByOrder = (a: MegaMenuColumn, b: MegaMenuColumn) => {
  return (
    +(b.SortColumnOrder != null) - +(a.SortColumnOrder != null) ||
    a.SortColumnOrder - b.SortColumnOrder
  );
};

export const sortColumnSection = (data: MegaMenuColumn) => {
  const columnsection = sortArray(data.ColumnAndSection);
  columnsection.forEach((sec) => {
    if (sec.Sections) {
      const Sections = sortArray(sec.Sections);
      Sections.forEach((e) => {
        if (e.Children) sortArray(e.Children);
      });
    }
    if (sec.Children) sortArray(sec.Children);
  });
};

export const sortColumnOrder = (columnsection: MegaMenuColumnSection[]) => {
  columnsection.sort(function (a, b) {
    return (
      +(b.mobileSortColumnOrder != null) - +(a.mobileSortColumnOrder != null) ||
      +(b.SortColumnOrder != null) - +(a.SortColumnOrder != null) ||
      +(b.SortSectionOrder != null) - +(a.SortSectionOrder != null) ||
      a.mobileSortColumnOrder - b.mobileSortColumnOrder ||
      a.SortColumnOrder - b.SortColumnOrder ||
      a.SortSectionOrder - b.SortSectionOrder
    );
  });
};
